import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Events = () => <VerticalPage config={VERTICALS['events']} />;

export default Events;
